import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { apiBaseUrlInterceptor } from '@core/interceptors/api-base-url.interceptor';
import { authInterceptor } from '@core/interceptors/auth.interceptor';
import { errorInterceptor } from '@core/interceptors/error.interceptor';
import { APP_ENVIRONMENT } from '@core/tokens/environment.token';
import { provideDataRepositories } from '@data/providers/data.providers';
import { environment } from '@env/environment';

export function provideCore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: APP_ENVIRONMENT, useValue: environment },
    provideHttpClient(
      withInterceptors([apiBaseUrlInterceptor, authInterceptor, errorInterceptor]),
    ),
    provideTranslateService({
      fallbackLang: environment.defaultLanguage || 'en',
      lang: environment.defaultLanguage || 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/i18n/',
        suffix: '.json',
      }),
    }),
    provideDataRepositories(),
  ]);
}
